import { call, put, takeEvery} from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGIN_USER_BY_TOKEN, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import BizinBackend from "../../../helpers/bizin_helper";

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import { isLoading } from "../../actions";

let errorMessage = 'Erro ao fazer login';

// const bizinBackend = getBizinBackend();
// const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "bizin") {
     
      const response = yield call(BizinBackend.loginUser, user.email, user.password, user._csrf, user.recaptchaToken );
      
      if(typeof response === 'undefined' || response?.message) { 
        yield put(apiError(response?.message || errorMessage))
      }else{
        localStorage.setItem("authUser", JSON.stringify(response));
        yield put(loginSuccess(response, response?.resultset_2[0]));
      }      
    }
    yield put(isLoading(false))
    // history("/");
  } catch (error) {
    console.log(error)    
    // Verifica a estrutura do erro para capturar a mensagem
    if (error.response) {
      if (error.response.data && typeof error.response.data === 'object') {
        if (Array.isArray(error.response.data.data)) {
          const errorData = error.response.data.data[0];
          errorMessage = errorData && errorData.message ? errorData.message : errorMessage;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }
    yield put(isLoading(false))
    yield put(apiError(errorMessage));
  }
}

function* loginUserByToken({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "bizin") {
     
      const response = yield call(BizinBackend.loginUserByToken, user.email, user.token, user._csrf);

      if(typeof response === 'undefined' || response?.statusError) {
        yield put(apiError(response.message))
        localStorage.removeItem("authUser");
        yield put(logoutUserSuccess(LOGOUT_USER, true));
        return;
      }
      
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response, response?.resultset_2[0]));
    }
    yield put(isLoading(false))
    window.location.reload();
    // history("/");
  } catch (error) {
    console.log(error)    
    // Verifica a estrutura do erro para capturar a mensagem
    if (error.response) {
      if (error.response.data && typeof error.response.data === 'object') {
        if (Array.isArray(error.response.data.data)) {
          const errorData = error.response.data.data[0];
          errorMessage = errorData && errorData.message ? errorData.message : errorMessage;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }
    yield put(isLoading(false))
    yield put(apiError(errorMessage));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGIN_USER_BY_TOKEN, loginUserByToken);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
